module.exports = __webpack_public_path__ + "static/media/phone.d1899d31.gif";